import type { CinematicOverrides, CinematicSequence } from '../../../../renderer/src/cinematic-sequence';

/** A property lane removes only its own override; the summary lane removes the whole key. */
export function deleteSceneKey(sequence: CinematicSequence, id: string, property?: keyof CinematicOverrides): CinematicSequence {
  const target = sequence.waypoints.find(item => item.id === id);
  if (!target || property && target.overrides[property] === undefined) return sequence;
  const overrides = { ...target.overrides };
  if (property) delete overrides[property];
  return { ...sequence, waypoints: sequence.waypoints.flatMap(item => {
    if (item.id !== id) return [item];
    return property && Object.keys(overrides).length ? [{ ...item, overrides }] : [];
  }) };
}
